/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eleven_Labs_Logo_AltInputs */

const en_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleven Labs logo`)
};

const fr_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo Eleven Labs`)
};

const de_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleven Labs Logo`)
};

const it_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo di Eleven Labs`)
};

const ru_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип Eleven Labs`)
};

const es_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo de Eleven Labs`)
};

const zh_cn2_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleven Labs 的标志`)
};

const ja_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イレブンラボのロゴ`)
};

const hi_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इलेवन लैब्स लोगो`)
};

const pt_pt2_eleven_labs_logo_alt = /** @type {(inputs: Eleven_Labs_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo da Eleven Labs`)
};

/**
* | output |
* | --- |
* | "Eleven Labs logo" |
*
* @param {Eleven_Labs_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const eleven_labs_logo_alt = /** @type {((inputs?: Eleven_Labs_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eleven_Labs_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_eleven_labs_logo_alt(inputs)
	if (locale === "de") return de_eleven_labs_logo_alt(inputs)
	if (locale === "it") return it_eleven_labs_logo_alt(inputs)
	if (locale === "ru") return ru_eleven_labs_logo_alt(inputs)
	if (locale === "es") return es_eleven_labs_logo_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_eleven_labs_logo_alt(inputs)
	if (locale === "ja") return ja_eleven_labs_logo_alt(inputs)
	if (locale === "hi") return hi_eleven_labs_logo_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_eleven_labs_logo_alt(inputs)
	return en_eleven_labs_logo_alt(inputs)
});